<HomeNavBar />

<div class="container-fluid p-3 p-md-4 my-orders-page">
    <div v-if="loading" class="text-center py-5">
      <div class="spinner-border text-primary mx-auto" role="status"></div>
      <p class="mb-0 mt-3">Loading your activity...</p>
    </div>

    <div v-else-if="error_message" class="card border-0 shadow-sm rounded-4 text-center py-5">
      <i class="bi bi-exclamation-circle text-danger display-6"></i>
      <p class="mb-3">{{ error_message }}</p>
      <button class="btn btn-primary btn-sm rounded shadow-sm" @click="get_my_orders">Try again</button>
    </div>

    <div v-else>
      <div class="row g-3 mb-4 d-none">
        <div v-for="stat in activity_stats" :key="stat.label" class="col-12 col-sm-6 col-xl-3">
          <div class="card border-0 shadow-sm rounded bg-gradient shadow-sm">
            <div class="card-body d-flex align-items-center gap-3">
              <div class="rounded-5 d-flex align-items-center justify-content-center text-primary bg-light p-3">
                <i :class="stat.icon"></i>
              </div>
              <div>
                <div class="fs-3 fw-bold text-dark">{{ stat.value }}</div>
                <div class="text-dark small">{{ stat.label }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row g-4 align-items-start my-orders-layout">
        <div class="col-12 col-xl-4 mobile-mt-remove">
          <div class="d-flex gap-2 p-2 my-orders-tabs mb-3 mt-4 rounded">
          <button
            class="btn btn-sm py-3 px-3 px-md-4 my-orders-tab-btn flex-fill rounded"
            :class="active_tab === 'orders' ? 'active' : ''"
            @click="active_tab = 'orders'"
          >
            <span class="d-inline-flex align-items-center">
              <i class="bi bi-bag"></i>
              <span class="me-2 ms-2">Orders</span>
            </span>
            <span class="badge my-orders-tab-badge rounded-circle d-inline-flex align-items-center justify-content-center">{{ orders_tab_count }}</span>
          </button>

          <button
            class="btn btn-sm py-3 px-3 px-md-4 my-orders-tab-btn flex-fill rounded"
            :class="active_tab === 'requests' ? 'active' : ''"
            @click="active_tab = 'requests'"
          >
            <span class="d-inline-flex align-items-center">
              <i class="bi bi-wrench-adjustable"></i>
              <span class="me-2 ms-2">Requests</span>
            </span>
            <span class="badge my-orders-tab-badge rounded-circle d-inline-flex align-items-center justify-content-center">
              {{ requests_tab_count }}
            </span>
          </button>
        </div>

          <div class="card border-0 shadow-sm rounded my-orders-sidebar">
            <div class="card-body p-3 p-lg-4">
              <button type="button"
                class="btn w-100 d-flex align-items-center justify-content-between gap-3 p-0 border-0 bg-transparent text-start my-orders-sidebar-toggle"
                @click="toggle_filter_panel">
                <div>
                  <h5 class="mb-1 fw-bold text-dark">{{ active_tab === 'orders' ? 'Orders' : 'Service Requests' }}</h5>
                  <div class="text-muted small">
                    {{ active_tab === 'orders' ? filtered_orders.length : filtered_requests.length }}
                    {{ active_tab === 'orders' ? 'orders' : 'requests' }}
                  </div>
                </div>
                <span v-if="is_small_device"
                  class="d-inline-flex align-items-center justify-content-center rounded-circle my-orders-sidebar-arrow">
                  <i :class="show_filter_panel ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                </span>
              </button>

              <div v-show="show_filter_panel" class="mt-3">
                <div class="mb-4">
                  <label class="form-label text-muted small fw-semibold">Search</label>
                  <div class="input-group form-control rounded bg-light shadow-sm">
                    <span class="input-group-text bg-light border-0">
                      <i class="bi bi-search text-muted"></i>
                    </span>
                    <input v-model="search_query" type="text" class="form-control bg-light border-0 shadow-none"
                      :placeholder="active_tab === 'orders' ? 'Search by name or ID...' : 'Search requests...'" />
                  </div>
                </div>

                <div>
                  <label class="form-label text-muted small fw-semibold">Filter By Status</label>
                  <div class="d-flex flex-column gap-2">
                    <button v-for="filter in filter_options" :key="filter.value"
                      class="btn text-start rounded-3 px-3 py-3 my-orders-filter-btn"
                      :class="current_filter() === filter.value ? 'btn-primary shadow-sm' : 'btn-light text-dark border'"
                      @click="set_filter(filter.value)">
                      {{ filter.label }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

          <div class="col-12 col-xl-8 pb-xl-0 mobile-bottom-space">
            <div class="d-flex align-items-xl-center mb-2 mb-md-2 justify-content-xl-end">
            <p class="text-muted mb-0 small my-orders-toolbar-note">Click any card to expand and view full details</p>
          </div>
          <div v-if="active_tab === 'orders'">
            <div v-if="!filtered_orders.length" class="card border-0 shadow-sm rounded text-center py-5 bg-light">
              <i class="bi bi-bag display-6 text-muted"></i>
              <p class="mb-0">No orders match your current search or filter.</p>
            </div>

            <div v-else class="scroll-container flex-column gap-3 pb-4">
              <div v-for="order in filtered_orders" :key="order.id"
                class="card border-0 border-start border-primary border-4 shadow-sm rounded overflow-hidden bg-light mb-2">
                <div class="card-body p-3 p-md-4" @click="toggle_expand(order)">
                  <div class="d-flex align-items-start justify-content-between gap-3">
                    <div class="d-flex align-items-center gap-3 min-w-0 flex-grow-1">
                      <div
                        class="rounded-5 d-flex align-items-center justify-content-center text-dark bg-secondary flex-shrink-0 p-3 border border-secondary">
                        <i class="bi bi-box-seam"></i>
                      </div>
                      <div class="min-w-0 w-100">
                        <div class="mb-1 w-100 d-flex align-items-start justify-content-between gap-2">
                          <h6 class="mb-0 fw-bold text-dark text-truncate flex-grow-1">{{ order?.order_number || order?.id }}</h6>
                        </div>
                        <div class="d-flex flex-wrap align-items-start gap-2 text-muted small">
                          <span>{{ format_short_date(order.created_at) }}</span>
                        </div>
                        <div class="mt-1 d-md-none">
                          <span
                            v-if="['approved', 'completed', 'delivered', 'resolved','paid'].includes(String(order?.order_status ).trim().toLowerCase())"
                            class="badge rounded border bg-success text-white border-success text-nowrap"
                          >
                            {{ format_status_label(order?.order_status) }}
                          </span>
                          <span
                            v-else-if="String(order?.order_status ).trim().toLowerCase() === 'pending'"
                            class="badge rounded-pill bg-warning text-dark text-xxs text-nowrap"
                          >
                            {{ order?.order_status ? order.order_status.charAt(0).toUpperCase() + order.order_status.slice(1).toLowerCase() : '' }}
                          </span>
                          <span
                            v-else-if="['completed', 'delivered', 'resolved'].includes(String(order?.order_status ).trim().toLowerCase())"
                            class="badge rounded-pill bg-info text-xxs text-nowrap"
                          >
                            {{ format_status_label(order?.order_status) }}
                          </span>
                          <span
                            v-else-if="['processing', 'in progress', 'in transit', 'transit'].includes(String(order?.order_status ).trim().toLowerCase())"
                            class="badge rounded border bg-warning-subtle text-warning-emphasis border-warning-subtle text-nowrap"
                          >
                            {{ format_status_label(order?.order_status) }}
                          </span>
                          <span
                            v-else-if="['declined', 'rejected', 'cancelled'].includes(String(order?.order_status ).trim().toLowerCase())"
                            class="badge rounded border bg-danger-subtle text-danger border-danger-subtle text-nowrap"
                          >
                            {{ format_status_label(order?.order_status) }}
                          </span>
                          <span v-else class="badge rounded border bg-light text-secondary text-nowrap">
                            {{ format_status_label(order?.order_status) }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex flex-column align-items-end justify-content-start gap-2 flex-shrink-0 ms-auto my-orders-card-actions">
                      <span
                        v-if="['approved', 'completed', 'delivered', 'resolved','paid'].includes(String(order?.order_status ).trim().toLowerCase())"
                        class="badge rounded border bg-success text-white border-success text-wrap d-none d-md-inline-flex"
                      >
                        {{ format_status_label(order?.order_status) }}
                      </span>
                      <span
                        v-else-if="String(order?.order_status ).trim().toLowerCase() === 'pending'"
                        class="badge rounded-pill bg-warning text-dark text-xxs text-wrap d-none d-md-inline-flex"
                      >
                        {{ order?.order_status ? order.order_status.charAt(0).toUpperCase() + order.order_status.slice(1).toLowerCase() : '' }}
                      </span>
                      <span
                        v-else-if="['completed', 'delivered', 'resolved'].includes(String(order?.order_status ).trim().toLowerCase())"
                        class="badge rounded-pill bg-info text-xxs text-wrap d-none d-md-inline-flex"
                      >
                        {{ format_status_label(order?.order_status) }}
                      </span>
                      <span
                        v-else-if="['processing', 'in progress', 'in transit', 'transit'].includes(String(order?.order_status ).trim().toLowerCase())"
                        class="badge rounded border bg-warning-subtle text-warning-emphasis border-warning-subtle text-wrap d-none d-md-inline-flex"
                      >
                        {{ format_status_label(order?.order_status) }}
                      </span>
                      <span
                        v-else-if="['declined', 'rejected', 'cancelled'].includes(String(order?.order_status ).trim().toLowerCase())"
                        class="badge rounded border bg-danger-subtle text-danger border-danger-subtle text-wrap d-none d-md-inline-flex"
                      >
                        {{ format_status_label(order?.order_status) }}
                      </span>
                      <span v-else class="badge rounded border bg-light text-secondary text-wrap d-none d-md-inline-flex">
                        {{ format_status_label(order?.order_status) }}
                      </span>
                      <div class="d-flex flex-column align-items-end justify-content-start gap-2 mt-0">
                        <div class="fw-bold text-xs text-dark text-nowrap d-none d-lg-block">
                          {{ format_currency(get_order_payable_total(order)) }}
                        </div>
                        <button class="btn btn-light border rounded-circle d-flex align-items-center justify-content-center small-circle-btn" type="button">
                          <i :class="order.is_expanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="order.is_expanded" class="border-top bg-light-subtle p-3 p-md-4">
                  <div class="row g-4">
                    <div class="col-12 col-lg-6 d-flex flex-column">
                      <div class="text-uppercase text-muted small fw-bold mb-3">Order Details</div>
                      <div class="card border-0 shadow-sm rounded bg-light border-0">
                        <div class="card-body">
                          <div
                            class="d-flex justify-content-between gap-3 py-2 border-bottom small my-orders-detail-row">
                            <span class="text-muted">Order ID</span>
                            <strong class="text-break text-end">{{ order?.order_number || order?.id }}</strong>
                          </div>
                          <div
                            class="d-flex justify-content-between gap-3 py-2 border-bottom small my-orders-detail-row">
                            <span class="text-muted">Supplier</span>
                            <strong class="text-break text-end">{{
                              order?.products?.[0]?.product?.company_name}}</strong>
                          </div>
                          <div
                            class="d-flex justify-content-between gap-3 py-2 border-bottom small my-orders-detail-row">
                            <span class="text-muted">Date</span>
                            <strong class="text-end">{{ format_short_date(order.created_at) }}</strong>
                          </div>
                          <div
                            class="d-flex justify-content-between gap-3 py-2 small my-orders-detail-row">
                            <span class="text-muted">Status</span>
                            <strong class="text-break text-end"> {{ format_status_label(order?.order_status) }}</strong>
                          </div>
                          <div
                            class="d-flex justify-content-between gap-3 py-2 border-bottom small my-orders-detail-row">
                            <span class="text-muted">Fulfilment Type</span>
                            <strong
                              v-if="order.pargo_delivery === null"
                              class="d-inline-flex align-items-center gap-1 text-break text-end"
                            >
                              <span>Collection</span>
                            </strong>
                            <strong
                              v-else
                              class="d-inline-flex align-items-center gap-1 text-break text-end"
                            >
                              <span>Delivery</span>
                            </strong>
                          </div>
                          <div
                            class="d-flex justify-content-between gap-3 py-2 border-bottom small my-orders-detail-row">
                            <span class="text-muted">Payment Type</span>
                            <strong class="text-break text-end">
                              {{String(order?.payment_type).trim().toLowerCase().includes('credit')? 'Paying on Credit': 'Pay Now'}}
                            </strong>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="get_order_rejection_reason(order)"
                        class="card border-0 shadow-sm rounded bg-light mt-auto"
                      >
                        <div class="card-body">
                          <div class="text-uppercase text-muted small fw-bold mb-2">Rejection Reason</div>
                          <p class="mb-0 small text-dark text-break">
                            {{ get_order_rejection_reason(order) }}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-lg-6">
                      <div class="text-uppercase text-muted small fw-bold mb-3">Items Ordered</div>
                      <div class="d-flex flex-column gap-2">
                        <div v-for="item in order.products || []" :key="item.id"
                          class="card border-0 shadow-sm rounded bg-light border-0">
                          <div
                            class="card-body d-flex justify-content-between align-items-center gap-3 py-3 flex-wrap flex-sm-nowrap">
                            <div class="d-flex align-items-center gap-2 min-w-0">
                              <img v-if="item.product?.images && item.product.images.length"
                                :src="item.product.images[0].image_url" alt="Product image" class="rounded border"
                                width="44" height="44" />

                              <div class="d-flex flex-column min-w-0">
                                <span class="text-break">{{ item.product?.name || item.product_name }}</span>
                                <small
                                  v-for="(attribute, index) in get_item_attributes(item)"
                                  :key="`${item.id}-attribute-${index}`"
                                  class="text-muted"
                                >
                                  {{ attribute.label }}: {{ attribute.value }}
                                </small>
                              </div>
                            </div>
                            <div
                              class="d-flex align-items-center justify-content-between gap-2 text-muted small my-orders-item-meta">
                              <span>x{{ item.quantity }}</span>
                              <strong class="text-dark">{{ format_money(item.total_price) }}</strong>
                            </div>
                          </div>
                        </div>
                        <div class="card border shadow-sm rounded bg-light border-0">
                          <div class="card-body py-3">
                            <div
                              v-if="has_order_promo(order)"
                              class="d-flex justify-content-between align-items-center mb-2"
                            >
                              <span class="text-muted">Subtotal</span>
                              <strong>{{ format_currency(get_order_subtotal(order)) }}</strong>
                            </div>
                            <div
                              v-if="has_order_promo(order)"
                              class="d-flex justify-content-between align-items-center mb-2 text-success"
                            >
                              <span class="fw-semibold">
                                <i class="bi bi-tag-fill me-1"></i>
                                Promo Discount
                              </span>
                              <strong>-{{ format_currency(get_order_discount_amount(order)) }}</strong>
                            </div>
                            <div
                              :class="[
                                'd-flex justify-content-between align-items-center',
                                has_order_promo(order) ? 'pt-2 border-top' : ''
                              ]"
                            >
                              <span>Total</span>
                              <strong>{{ format_currency(get_order_payable_total(order)) }}</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex flex-column flex-md-row justify-content-end gap-2 mt-4 pt-3 border-top">
                    <button class="btn btn-sm btn-light border rounded" @click.stop="toggle_expand(order)">Close</button>
                    <button
                      v-if="can_cancel_order(order)"
                      class="btn btn-sm btn-danger rounded shadow-sm"
                      :disabled="is_cancelling_order(order)"
                      @click.stop="cancel_order(order)"
                    >
                      <span v-if="is_cancelling_order(order)">
                        <i class="bi bi-arrow-repeat spin me-1"></i>
                        Cancelling...
                      </span>
                      <span v-else>
                        Cancel Order
                      </span>
                    </button>
                    <button v-if="String(order?.order_status).trim().toLowerCase() === 'credit'"
                      class="badge rounded text-muted border border-success-subtle px-3 py-2 orders-action-control">
                      {{
                        String(order?.order_status).trim().toLowerCase() === 'credit'
                          ? 'Settle Credit'
                          : `Pay on ${order.pargo_delivery === null ? 'Collection' : 'Delivery'}`
                      }}
                    </button>
                      <button v-if="String(order?.order_status).trim().toLowerCase() === 'approved'"
                      class="btn btn-sm btn-primary rounded px-3 py-2 orders-action-control" @click="view_order(order)">
                        Pay now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else>
            <div v-if="!filtered_requests.length" class="card border-0 shadow-sm rounded-4 text-center py-5">
              <i class="bi bi-wrench display-6 text-muted"></i>
              <p class="mb-0">No service requests match your current search or filter.</p>
            </div>

            <div v-else class="scrollable-container flex-column gap-3 pb-4">
              <div v-for="request in filtered_requests" :key="request.id"
                class="card border-0 border-start border-primary border-4 shadow-sm rounded overflow-hidden bg-light mb-2">
                
                <div class="card-body p-3 p-md-4" @click="toggle_expand(request)" style="cursor: pointer;">
                  <div class="d-flex align-items-start justify-content-between gap-3">
                    
                    <div class="d-flex align-items-center gap-3 min-w-0 flex-grow-1">
                      <div class="rounded-5 d-flex align-items-center justify-content-center text-dark bg-secondary flex-shrink-0 p-3 border border-secondary">
                        <i class="bi bi-wrench-adjustable"></i>
                      </div>
                      
                      <div class="min-w-0 w-100">
                        <div class="mb-1 w-100 d-flex align-items-start justify-content-between gap-2">
                          <h6 class="mb-0 fw-bold text-dark text-truncate">
                            {{ request.product?.name || request.service?.name || 'Service Request' }}
                          </h6>
                        </div>
                        
                        <div class="d-flex flex-wrap align-items-start gap-2 text-muted small">
                          <span>{{ format_short_date(request.created_at || request.request_date) }}</span>
                        </div>
                        
                        <div v-if="String(request?.status?.name).trim().toLowerCase() === 'completed'" class="mt-2" @click.stop>
                          <div class="d-inline-flex align-items-center gap-2 p-1 px-2 bg-soft-success rounded border border-success border-opacity-10 text-xxs">
                            <i class="bi bi-info-circle-fill text-success small"></i>
                            <span class="text-dark fw-bold text-xxs">Please confirm if this service was rendered.</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex flex-column align-items-end justify-content-start gap-2 flex-shrink-0 ms-auto my-orders-card-actions">
                      
                      <span v-if="String(request?.status?.name).trim().toLowerCase() === 'approved'"
                        class="badge rounded-pill bg-success text-xxs text-wrap">
                        {{ request?.status?.name ? request.status.name.charAt(0).toUpperCase() + request.status.name.slice(1).toLowerCase() : '' }}
                      </span>
                      <span v-else-if="String(request?.status?.name).trim().toLowerCase() === 'pending'"
                        class="badge rounded-pill bg-warning text-dark text-xxs text-wrap">
                        {{ request?.status?.name ? request.status.name.charAt(0).toUpperCase() + request.status.name.slice(1).toLowerCase() : '' }}
                      </span>
                      <span v-else-if="String(request?.status?.name).trim().toLowerCase() === 'completed'"
                        class="badge rounded-pill bg-success text-xxs text-wrap">
                        {{ request?.status?.name ? request.status.name.charAt(0).toUpperCase() + request.status.name.slice(1).toLowerCase() : '' }}
                      </span>
                      <span v-else-if="String(request?.status?.name).trim().toLowerCase() === 'confirmed'"
                        class="badge rounded-pill bg-secondary text-xxs text-wrap">
                        {{ request?.status?.name ? request.status.name.charAt(0).toUpperCase() + request.status.name.slice(1).toLowerCase() : '' }}
                      </span>
                      <span v-else-if="String(request?.status?.name).trim().toLowerCase() === 'disputed'"
                        class="badge rounded-pill bg-dark text-white text-xxs text-wrap">
                        {{ request?.status?.name ? request.status.name.charAt(0).toUpperCase() + request.status.name.slice(1).toLowerCase() : '' }}
                      </span>
                      <span v-else-if="['declined', 'rejected', 'cancelled'].includes(String(request?.status?.name).trim().toLowerCase())"
                        class="badge rounded-pill bg-danger text-xxs text-wrap">
                        {{ request?.status?.name ? request.status.name.charAt(0).toUpperCase() + request.status.name.slice(1).toLowerCase() : '' }}
                      </span>
                      <span v-else class="badge rounded-pill bg-primary text-xxs text-wrap">
                        {{ request?.status?.name ? request.status.name.charAt(0).toUpperCase() + request.status.name.slice(1).toLowerCase() : '' }}
                      </span>

                      <div class="d-flex flex-column align-items-end justify-content-start gap-2 mt-0">
                        <button class="btn btn-light border rounded-circle d-flex align-items-center justify-content-center small-circle-btn" type="button">
                          <i :class="request.is_expanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                        </button>
                      </div>
                    </div>

                  </div>
                </div>

                <div v-if="request.is_expanded" class="border-top bg-light-subtle p-3 p-md-4">
                  <div class="row g-4">
                    
                    <div class="col-12 col-lg-6">
                      <div class="text-uppercase text-muted small fw-bold mb-3">Request Details</div>
                      <div class="card border-0 shadow-sm rounded bg-light border-0">
                        <div class="card-body">
                          <div class="d-flex justify-content-between gap-3 py-2 border-bottom small my-orders-detail-row">
                            <span class="text-muted">Company</span>
                            <strong class="text-break text-end">{{ request?.product?.base_profile?.company?.company_name }}</strong>
                          </div>
                          <div class="d-flex justify-content-between gap-3 py-2 border-bottom small my-orders-detail-row">
                            <span class="text-muted">Date Created</span>
                            <strong class="text-end">{{ format_short_date(request.created_at || request.request_date) }}</strong>
                          </div>
                          <div class="d-flex justify-content-between gap-3 py-2 border-bottom small my-orders-detail-row">
                            <span class="text-muted">Preferred Date</span>
                            <strong class="text-end">{{ format_short_date(request.request_date) }}</strong>
                          </div>
                          <div class="d-flex justify-content-between gap-3 py-2 small my-orders-detail-row">
                            <span class="text-muted">Status</span>
                            <strong class="text-break text-end">{{ format_status_label(request?.status?.name) }}</strong>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-lg-6">
                      <div class="text-uppercase text-muted small fw-bold mb-3">
                        {{
                          ['cancelled'].includes(String(request?.status?.name).trim().toLowerCase())
                            ? 'Your Reason for Cancelling'
                            : `Response From ${request?.product?.base_profile?.company?.company_name || ''}`
                        }}
                      </div>
                      <div class="card border-0 shadow-sm rounded bg-light border-0">
                        <div class="card-body">
                          <p v-if="request?.return_message" class="mb-0 text-dark small">
                            {{ request?.return_message }}
                          </p>
                          <p v-else class="mb-0 text-muted small fst-italic">
                            {{
                              ['cancelled'].includes(String(request?.status?.name).trim().toLowerCase())
                                ? 'No cancellation reason provided'
                                : 'No response'
                            }}
                          </p>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="d-flex flex-column flex-md-row justify-content-end gap-2 mt-4 pt-3 border-top">
                  
                  <div v-if="request.show_cancel_input" class="w-100 me-md-auto">
                  <textarea v-model="request.cancel_reason"  rows="2" class="form-control form-control-sm rounded mb-2 text-xxs" placeholder="Reason for declining..."></textarea>

                    <div class="d-flex justify-content-end gap-2">
                      <button class="btn btn-sm text-xxs btn-light border rounded" @click.stop="request.show_cancel_input = false">Back</button>
                      <button class="btn btn-sm btn-danger rounded shadow-sm" @click.stop="update_service_request_status(request, 'cancelled')">
                        Submit Cancellation
                      </button>
                    </div>
                  </div>

                  <div v-if="!request.show_cancel_input">
                    <button v-if="['pending', 'approved'].includes(String(request?.status?.name).trim().toLowerCase())"
                      class="btn btn-sm btn-danger rounded shadow-sm" 
                      @click.stop="request.show_cancel_input = true">
                      <i class="bi bi-x-circle me-1"></i> Cancel Request
                    </button>

                    <button v-if="String(request?.status?.name).trim().toLowerCase() === 'completed'"
                      class="btn btn-sm btn-danger rounded shadow-sm me-2"
                      @click.stop="prompt_dispute_request(request)">
                      Report Issue
                    </button>

                    <button v-if="String(request?.status?.name).trim().toLowerCase() === 'completed'"
                      class="btn btn-sm btn-primary rounded shadow-sm" 
                      @click.stop="update_service_request_status(request, 'confirmed')">
                      Confirm Rendered
                    </button>
                  </div>
                </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  <!-- Rating Modal -->
  <div class="modal fade" id="ratingModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content rounded-5 shadow border-0 overflow-hidden">
        <div class="modal-header bg-primary text-white border-0 p-4 pb-3">
          <h5 class="modal-title fw-bold">Rate this Service</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-4 pt-2 text-center">
          <div class="mb-4">
            <div class="p-3 bg-light rounded-4 mb-3">
              <p class="text-muted mb-1 small fw-bold text-uppercase ls-1">Rating Service</p>
              <h6 class="fw-bold text-dark mb-1">{{ rating_request?.product?.name || rating_request?.service?.name ||
                'Service' }}</h6>
              <p class="text-muted small mb-0">by {{ rating_request?.product?.base_profile?.company?.company_name ||
                rating_request?.company_name }}</p>
            </div>
            <p class="text-muted small">Your feedback helps the community choose the best businesses!</p>
          </div>

          <div class="d-flex justify-content-center gap-2 mb-2">
            <i v-for="n in 5" :key="n" class="bi fs-2 pointer transition-all"
              :class="n <= (hover_rating || new_rating) ? 'bi-star-fill text-warning' : 'bi-star text-secondary'"
              @mouseenter="hover_rating = n" @mouseleave="hover_rating = 0" @click="new_rating = n">
            </i>
          </div>

          <p class="fw-bold text-primary mb-4">{{ rating_level }}</p>

          <div class="form-floating mb-4">
            <textarea v-model="new_review_text" class="form-control rounded-4 bg-light border-0"
              placeholder="Leave a comment" id="ratingComment" style="height: 120px"></textarea>
            <label for="ratingComment" class="text-muted small">Share more about your experience...</label>
          </div>

          <button class="btn btn-primary w-100 rounded py-3 fw-bold shadow-sm"
            :disabled="!new_rating || !new_review_text.trim() || isSubmittingRating" @click="submit_rating">
            <span v-if="isSubmittingRating" class="spinner-border spinner-border-sm me-2"></span>
            Submit Review
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
